import { Record, Union } from "./fable_modules/fable-library.4.10.0/Types.js";
import { MainModels_SettingsCard, MediaCategory, RESP$1_$reflection, MainModels_SettingsCard_$reflection } from "../shared/Shared.fs.js";
import { getRecordField, getUnionFields, isUnion, obj_type, getRecordElements, name, record_type, bool_type, option_type, union_type, anonRecord_type, unit_type, class_type, string_type } from "./fable_modules/fable-library.4.10.0/Reflection.js";
import { empty, FSharpMap__Remove, FSharpMap__Add } from "./fable_modules/fable-library.4.10.0/Map.js";
import { newGuid } from "./fable_modules/fable-library.4.10.0/Guid.js";
import { apiCmd, uploadFileToS3Cmd, noCmd } from "./Common.fs.js";
import { comparePrimitives } from "./fable_modules/fable-library.4.10.0/Util.js";
import { value as value_1 } from "./fable_modules/fable-library.4.10.0/Option.js";
import { tryFind } from "./fable_modules/fable-library.4.10.0/Array.js";
import { FSharpResult$2 } from "./fable_modules/fable-library.4.10.0/Choice.js";
import { empty as empty_1, singleton, append, delay, toList } from "./fable_modules/fable-library.4.10.0/Seq.js";
import * as react from "react";
import { imgArea128, errors } from "./MainTemplates.fs.js";
import { HTMLAttr } from "./fable_modules/Fable.React.9.4.0/Fable.React.Props.fs.js";
import { Internal_updateInputValue } from "./fable_modules/Fable.Elmish.React.5.0.0/./common.fs.js";
import { keyValueList } from "./fable_modules/fable-library.4.10.0/MapUtil.js";

export class Msg extends Union {
    constructor(tag, fields) {
        super();
        this.tag = tag;
        this.fields = fields;
    }
    cases() {
        return ["SettingsResp", "UpdateMixlrCode", "QuizImgChanged", "QuizImgClear", "QuizImgUploaded", "DeleteError", "Submit", "Exn"];
    }
}

export function Msg_$reflection() {
    return union_type("MainProdSettings.Msg", [], Msg, () => [[["Item", RESP$1_$reflection(MainModels_SettingsCard_$reflection())]], [["Item", string_type]], [["Item", anonRecord_type(["File", class_type("Browser.Types.File", void 0)], ["Tag", unit_type])]], [["Item", unit_type]], [["Item", string_type]], [["Item", string_type]], [], [["Item", class_type("System.Exception")]]]);
}

export class Model extends Record {
    constructor(Settings, Errors, IsLoading) {
        super();
        this.Settings = Settings;
        this.Errors = Errors;
        this.IsLoading = IsLoading;
    }
}

export function Model_$reflection() {
    return record_type("MainProdSettings.Model", [], Model, () => [["Settings", option_type(MainModels_SettingsCard_$reflection())], ["Errors", class_type("Microsoft.FSharp.Collections.FSharpMap`2", [string_type, string_type])], ["IsLoading", bool_type]]);
}

export function addError(txt, model) {
    let copyOfStruct;
    return new Model(model.Settings, FSharpMap__Add(model.Errors, (copyOfStruct = newGuid(), copyOfStruct), txt), model.IsLoading);
}

export function delError(id, model) {
    return new Model(model.Settings, FSharpMap__Remove(model.Errors, id), model.IsLoading);
}

export function loading(model) {
    return new Model(model.Settings, model.Errors, true);
}

export function editing(model) {
    return new Model(model.Settings, model.Errors, false);
}

export function uploadFileS3(api, file, model) {
    if (file.size > (1024 * 128)) {
        return noCmd(addError("max image size is 128K", model));
    }
    else {
        return [loading(model), uploadFileToS3Cmd(api.getUploadUrl, new MediaCategory(0, []), file, (Item) => (new Msg(4, [Item])), (Item_1) => (new Msg(7, [Item_1])))];
    }
}

export function settings(f, model) {
    const matchValue = model.Settings;
    if (matchValue == null) {
        return model;
    }
    else {
        return new Model(f(matchValue), model.Errors, model.IsLoading);
    }
}

export function init(api, user) {
    return apiCmd(api.getSettings, void 0, (Item) => (new Msg(0, [Item])), (Item_1) => (new Msg(7, [Item_1])), new Model(void 0, empty({
        Compare: comparePrimitives,
    }), true));
}

export function update(api, user, msg, cm) {
    switch (msg.tag) {
        case 1:
            return noCmd(settings((s) => (new MainModels_SettingsCard(s.UserId, s.DefaultImg, msg.fields[0].trim())), cm));
        case 3:
            return noCmd(settings((s_1) => (new MainModels_SettingsCard(s_1.UserId, "", s_1.DefaultMixlr)), cm));
        case 2:
            return uploadFileS3(api, msg.fields[0].File, cm);
        case 4:
            return noCmd(settings((s_2) => (new MainModels_SettingsCard(s_2.UserId, msg.fields[0], s_2.DefaultMixlr)), editing(cm)));
        case 6: {
            const model_11 = loading(cm);
            return apiCmd(api.updateSettings, value_1(cm.Settings), (Item) => (new Msg(0, [Item])), (Item_1) => (new Msg(7, [Item_1])), model_11);
        }
        case 5:
            return noCmd(delError(msg.fields[0], cm));
        case 7:
            return noCmd(editing(addError(msg.fields[0].message, cm)));
        default:
            if (msg.fields[0].Value.tag === 0) {
                return noCmd(editing(new Model(msg.fields[0].Value.fields[0], cm.Errors, cm.IsLoading)));
            }
            else {
                let activePatternResult;
                const msg_1 = msg;
                const pi_1 = tryFind((pi) => (name(pi) === "Value"), getRecordElements(RESP$1_$reflection(obj_type)));
                if (pi_1 == null) {
                    activePatternResult = void 0;
                }
                else {
                    const pi$0027 = pi_1;
                    let msgType;
                    let copyOfStruct = msg_1;
                    msgType = Msg_$reflection();
                    if (isUnion(msgType)) {
                        const objArray = getUnionFields(msg_1, msgType)[1];
                        if (objArray.length === 1) {
                            try {
                                const patternInput_1 = getUnionFields(getRecordField(objArray[0], pi$0027), union_type("Microsoft.FSharp.Core.FSharpResult`2", [obj_type, obj_type], FSharpResult$2, () => [[["ResultValue", obj_type]], [["ErrorValue", obj_type]]]));
                                activePatternResult = ((name(patternInput_1[0]) === "Error") ? patternInput_1[1][0] : void 0);
                            }
                            catch (matchValue) {
                                activePatternResult = void 0;
                            }
                        }
                        else {
                            activePatternResult = void 0;
                        }
                    }
                    else {
                        activePatternResult = void 0;
                    }
                }
                if (activePatternResult != null) {
                    const txt_3 = activePatternResult;
                    return noCmd(editing(addError(txt_3, cm)));
                }
                else {
                    return noCmd(cm);
                }
            }
    }
}

export function view(dispatch, user, appSettings, model) {
    const children_38 = toList(delay(() => append(model.IsLoading ? singleton(react.createElement("button", {
        className: "button is-loading is-large is-fullwidth is-dark",
    })) : empty_1(), delay(() => append(singleton(errors(dispatch, (Item) => (new Msg(5, [Item])), model.Errors)), delay(() => {
        let props_40, children_36, children_6, children_4, children_28, children_20, children_18, children_10, children_16, children_26, children_24, children_34, children_32;
        const matchValue = model.Settings;
        if (matchValue == null) {
            return empty_1();
        }
        else {
            const settings_1 = matchValue;
            return singleton((props_40 = [new HTMLAttr(65, ["has-background-light has-text-dark"]), ["style", {
                padding: "12px",
            }]], (children_36 = [(children_6 = [react.createElement("label", {
                className: "label",
            }, "User Id"), (children_4 = [react.createElement("input", {
                className: "input",
                type: "text",
                readOnly: true,
                value: settings_1.UserId,
            })], react.createElement("div", {
                className: "control",
            }, ...children_4))], react.createElement("div", {
                className: "field",
            }, ...children_6)), (children_28 = [(children_20 = [(children_18 = [react.createElement("label", {
                className: "label",
            }, "Default Mixlr Login"), (children_10 = [react.createElement("input", {
                className: "input",
                type: "text",
                placeholder: "",
                maxLength: 128,
                ref: (e) => {
                    Internal_updateInputValue(settings_1.DefaultMixlr, e);
                },
                readOnly: model.IsLoading,
                onChange: (ev) => {
                    dispatch(new Msg(1, [ev.target.value]));
                },
            })], react.createElement("div", {
                className: "control",
            }, ...children_10)), (children_16 = ["https://", react.createElement("span", {
                className: "has-text-danger",
            }, "LOGIN"), ".mixlr.com/embed from ", react.createElement("a", {
                href: "https://creators.mixlr.com/settings/embed-player/edit",
            }, "Widget code")], react.createElement("small", {}, ...children_16))], react.createElement("div", {
                className: "field",
            }, ...children_18))], react.createElement("div", {
                className: "column",
            }, ...children_20)), (children_26 = [(children_24 = toList(delay(() => append(singleton(react.createElement("label", {
                className: "label",
            }, "Default Quiz Picture (128x128) 128K Size Max")), delay(() => imgArea128(void 0, model.IsLoading, (arg) => {
                dispatch(new Msg(2, [arg]));
            }, () => {
                dispatch(new Msg(3, [void 0]));
            }, appSettings.MediaHost, settings_1.DefaultImg, "/logo256.png", "Reset to default"))))), react.createElement("div", {
                className: "field",
            }, ...children_24))], react.createElement("div", {
                className: "column",
            }, ...children_26))], react.createElement("div", {
                className: "columns",
            }, ...children_28)), (children_34 = [(children_32 = [react.createElement("button", {
                className: "button is-dark ",
                disabled: model.IsLoading,
                onClick: (_arg) => {
                    dispatch(new Msg(6, []));
                },
            }, "Submit")], react.createElement("div", {
                className: "control",
            }, ...children_32))], react.createElement("div", {
                className: "field is-grouped",
            }, ...children_34))], react.createElement("div", keyValueList(props_40, 1), ...children_36))));
        }
    }))))));
    return react.createElement("div", {}, ...children_38);
}

